document.addEventListener('DOMContentLoaded', function () {
  const lazyVideos = document.querySelectorAll('.js-lazy-video');

  function forcePlay(video) {
    video.muted = true;
    video.play().then(() => {
      setTimeout(() => {
        video.play().catch(err => {
          console.log('Second play() failed:', err);
        });
      }, 100);
    }).catch(err => {
      console.log('First play() failed:', err);
    });
  }

  function loadVideoSources(video) {
    const sources = video.querySelectorAll('source');
    let hasLoaded = false;

    sources.forEach(source => {
      if (source.dataset.src) {
        source.src = source.dataset.src;
        hasLoaded = true;
      }
    });

    if (hasLoaded) {
      video.load();
    }
  }

  function handleVideo(video) {
    loadVideoSources(video);
    video.controls = false;

    if (video.hasAttribute('autoplay')) {
      forcePlay(video);
    }

    const parentAnimation = video.closest('.js-aos-animation');
    if (parentAnimation) {
      parentAnimation.classList.add('active');
    }
  }

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          handleVideo(entry.target);
          videoObserver.unobserve(entry.target);
        }
      });
    });

    lazyVideos.forEach(video => videoObserver.observe(video));
  } else {
    lazyVideos.forEach(handleVideo);
  }
});